import React from "react";

const AdminDashboardProgressTable = ({ game }) => {
  const time = 300 - game?.remainingTime;
  const present = Math.ceil((time / 300) * 100, 2);
  console.log(300 - game?.remainingTime);
  // ..
  return (
    <tr className="border-b border-slate-200">
      <td className="h-16 px-6  transition duration-300 border-slate-200 stroke-black text-black ">
        {game?.gameName}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 whitespace-nowrap">
        {game?.date} , {game?.time}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        <div class="h-2 w-full bg-neutral-200  rounded-full">
          <div
            class="h-2 bg-secondary rounded-full"
            style={{ width: `${present}%` }}
          ></div>
        </div>
      </td>
    </tr>
  );
};

export default AdminDashboardProgressTable;
